import { render, staticRenderFns } from "./aftersale.vue?vue&type=template&id=a29de994&scoped=true"
import script from "./aftersale.vue?vue&type=script&lang=js"
export * from "./aftersale.vue?vue&type=script&lang=js"
import style0 from "./aftersale.vue?vue&type=style&index=0&id=a29de994&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29de994",
  null
  
)

export default component.exports